import * as lodash from 'lodash'
import { Injectable } from '@angular/core'
import { MessageView } from '@tv3/store/message/message.view'
import { FilterFormGroup } from '@tokeet/tv3-platform'
import { Store } from '@ngrx/store'
import * as fromRoot from '@tv3/store/state'
import { FormBuilder } from '@angular/forms'
import { UserStorage } from '@tv3/services/utils/storage.service'
import { FilterGroup } from '@tv3/services/utils/filters.service'
import { selectAllInboundMessageViews } from '@tv3/store/message/message.selectors'
import * as R from 'ramda'
import { CheckInStatus } from '@tv3/store/inquiry/inquiry.model'
import { SearchPipe } from '@tv3/pipes/utility/search.pipe'

export enum BookingStatus {
  Inquiry,
  Arriving,
  InHouse,
  Departed,
}

export enum MessageReadStatus {
  Read,
  Unread,
}

@Injectable({ providedIn: 'root' })
export class MessageFilters {
  defaultValues = {
    rentals: [],
    status: null,
    readStatus: null,
    type: null,
    search: '',
  }

  filters = {
    rentals: (messages: MessageView[], rentals: string[]) => {
      return R.filter((m: MessageView) => R.contains(m.rentalId, rentals), messages)
    },
    status: (messages: MessageView[], status: BookingStatus) => {
      if (status === BookingStatus.Inquiry) {
        return messages.filter((m) => lodash.get(m, 'inquiry.booked') === 0)
      }
      if (status === BookingStatus.Arriving) {
        return messages.filter((m) => lodash.get(m, 'inquiry.checkInStatus') === CheckInStatus.Arriving)
      }
      if (status === BookingStatus.InHouse) {
        return messages.filter((m) => lodash.get(m, 'inquiry.checkInStatus') === CheckInStatus.CheckedIn)
      }
      if (status === BookingStatus.Departed) {
        return messages.filter((m) => lodash.get(m, 'inquiry.checkInStatus') === CheckInStatus.CheckedOut)
      }
      return messages
    },
    readStatus: (messages: MessageView[], readStatus: MessageReadStatus) => {
      if (readStatus === MessageReadStatus.Read) {
        return messages.filter((m) => m.read)
      } else if (readStatus === MessageReadStatus.Unread) {
        return messages.filter((m) => !m.read)
      }
      return messages
    },
    search: (messages: MessageView[], term: string) => {
      return this.searchPipe.transform(messages, 'messageTxt,subject,guestName,name,rentalName', term)
    },
  }

  group: FilterFormGroup<MessageView>

  constructor(
    private store: Store<fromRoot.State>,
    private fb: FormBuilder,
    private storage: UserStorage,
    private searchPipe: SearchPipe
  ) {
    const storedFilters = this.storage.get(FilterGroup.MessageFeed, this.defaultValues)

    const group = this.fb.group({
      rentals: [storedFilters.rentals],
      status: [storedFilters.status],
      readStatus: [storedFilters.readStatus],
      search: [storedFilters.search],
    })

    this.group = new FilterFormGroup<MessageView>(
      group.controls,
      this.store,
      this.storage,
      FilterGroup.MessageFeed,
      selectAllInboundMessageViews,
      this.filters
    )
  }
}
